import React, { FunctionComponent } from 'react';
import { useTranslate } from 'react-admin';
import { getBooleanLabel } from '../../../../../../helpers/history';
import { BoolFieldProps } from './type';

const BoolField: FunctionComponent<BoolFieldProps> = (props) => {
  const t = useTranslate();
  const { details } = props;

  const before = getBooleanLabel(details.args?.before, t);
  const after = getBooleanLabel(details.args?.after, t);

  return (
    <span>{t(`${details.translation_key}.details`, { before, after })}</span>
  );
};

export default BoolField;
